export default __webpack_public_path__ + "static/media/DSC_7519.2f047218.jpg";